/** Fecha local del runtime en `YYYY-MM-DD` (calendario del dispositivo o del servidor Node según dónde se ejecute). */
export function localDateToIsoDate(d: Date = new Date()): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}
